// A short, synthesized two-note chime for the "new email arrived" toast
// (see Sidebar.js) -- confirmed with the user, 2026-10-29. Generated via
// the Web Audio API rather than shipping an actual audio file: no asset
// to source/license, and it's a handful of lines either way.
//
// Browsers block audio from playing until the user has interacted with
// the page at least once (autoplay policy) -- by the time this fires
// (a 15s-interval poll, well after page load), that's almost always
// already true, but playNotificationSound() still fails silently rather
// than throwing if it isn't, so a blocked chime never breaks the toast
// itself.
let sharedAudioContext = null;

const getAudioContext = () => {
  if (sharedAudioContext) return sharedAudioContext;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  sharedAudioContext = new Ctx();
  return sharedAudioContext;
};

export const playNotificationSound = () => {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume();

    const playTone = (frequency, startTime, duration) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency, startTime);
      // Quick fade in/out so each note is a soft "ding", not a harsh click.
      gain.gain.setValueAtTime(0, startTime);
      gain.gain.linearRampToValueAtTime(0.2, startTime + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    };

    const now = ctx.currentTime;
    playTone(880, now, 0.18); // A5
    playTone(1318.5, now + 0.14, 0.22); // E6 -- the little "lift" at the end
  } catch (error) {
    // Autoplay blocked, or no Web Audio support -- the toast itself still
    // shows regardless, so this is never worth surfacing to the user.
    console.error("Failed to play notification sound:", error);
  }
};
